enum MovementServiceTypeEnum {
  FIXED = 'FIXED',
  NEW_CONTRACT = 'NEW_CONTRACT',
  ACTIVE_CONTRACT = 'ACTIVE_CONTRACT',
}

export { MovementServiceTypeEnum };
